import { useState, useEffect } from 'react';
import { useDebounce } from './useDebounce';

interface UseFilteredItemsProps<T, K> {
	items: T[];
	searchTerm: string;
	status: K | null;
	filterFn: (item: T, searchTerm: string, status: K | null) => boolean;

}


export const useFilteredItems = <T, K>({
	items,
	searchTerm,
	status,
	filterFn,
}: UseFilteredItemsProps<T, K>) => {
	const [filteredItems, setFilteredItems] = useState<T[]>(items);
	const [filterLoading, setFilterLoading] = useState(false);
	const debouncedSearchTerm = useDebounce(searchTerm, 500);
	const [filterEstado, setFilterEstado] = useState<string>('');

	const handleFilterEstado = (estad: string) => {
		setFilterEstado(estad);
		applyFilters()
	}

	const applyFilters = () => {
		if (items.length === 0) {
			setTimeout(() => setFilterLoading(false), 1000);
			return;
		}
	
		setFilterLoading(true);
	
		const filterItems = () => {
			const filtered = items.filter((item) => {
				const isEstadoMatch = filterEstado ? (item as any).estado === filterEstado : true;
				return filterFn(item, debouncedSearchTerm, status) && isEstadoMatch;
			});
	
			setFilteredItems(filtered);
			setTimeout(() => setFilterLoading(false), 100);
		};
	
		const timeoutId = setTimeout(filterItems, 1000);
	
		return () => clearTimeout(timeoutId);
	};
	
	useEffect(() => {
		applyFilters();
	}, [debouncedSearchTerm, items, filterFn, status, filterEstado]);
	

	return { filteredItems, filterLoading, handleFilterEstado };
};
